import fetch from 'auth/FetchInterceptor'

const CodeService = {}

CodeService.selectCodesList = () => {
  return fetch({
    url: '/code/select-codes-list',
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
  })
}

CodeService.selectErpCodesList = data => {
  return fetch({
    url: '/code/select-erp-codes-list',
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
    data: data,
  })
}

export default CodeService
